import { render, staticRenderFns } from "./NotificationsTable.vue?vue&type=template&id=330adba8&scoped=true"
import script from "./NotificationsTable.vue?vue&type=script&lang=js"
export * from "./NotificationsTable.vue?vue&type=script&lang=js"
import style0 from "./NotificationsTable.vue?vue&type=style&index=0&id=330adba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330adba8",
  null
  
)

export default component.exports